import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'

// local components
import ReportingBroadcast from './ReportingBroadcast'
import InsightsExport from './InsightsExport'
import SyncInsights from './InsightsSync'
import { RouteConstants } from '../../../utils/constants'
import SystemActivityLogMFE from '../Company/SystemActivityLogMFE'

export default class InsightsPage extends PureComponent {
  render() {
    const { match } = this.props
    return (
      <Fragment>
        <Route exact path={`${match.url}/broadcast`} component={ReportingBroadcast} />
        <Route exact path={`${match.url}/insightsExport`} component={InsightsExport} />
        <Route exact path={`${match.url}/syncInsightsPermissions`} component={SyncInsights} />
        <Route path={RouteConstants.SYSTEM_ACTIVITY_LOGS().BASE} component={SystemActivityLogMFE} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Insights/InsightsPage.js